import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilterSlash} from "@fortawesome/pro-solid-svg-icons";
import React from "react";

const ComboBoxNoResults = () => {
    return (
        <div
            className={`item-menu-entry flex-column disabled align-center justify-center`}
            title={'No Matches Found'}
        >
            <FontAwesomeIcon icon={faFilterSlash} fixedWidth={true} size={"2x"} />
            <h6 className={'sm-sub-heading mt-sm mb-0'}>No Match Found</h6>
        </div>
    )
}

export default ComboBoxNoResults